module.exports = __webpack_public_path__ + "2ec38e2aecf10472150e94402e3d250d.png";